<div [ngClass]="{ 'hcf-popup-modal': true, 'show-popup': showPopup }" (click)="closePopup()"></div>
<div [ngClass]="{ 'hcf-popup': true, 'show-popup': showPopup }">
  <a (click)="closePopup()" aria-label="Close" title="Close" class="hcf-popup-close"></a>
  <ng-content></ng-content>
</div>
